module.exports = __webpack_public_path__ + "assets/img/in-page.cae45a45.webp";